import React, { useContext, useEffect, useRef, useState } from "react";
import Header from "../components/Header/Header";
import MobileNavbar from "../components/Header/Mobile/MobileNavbar";
import MobileHeader from "../components/Header/Mobile/MobileHeader";
import ScrollTop from "../components/shared/ScrollTop";
import Footer from "../components/Footer/Footer";
import design from "../images/web-design.png";
import { FaPhp, FaReact, FaLaravel, FaWordpress } from "react-icons/fa";
import { SiTailwindcss } from "react-icons/si";
import { FaCode } from "react-icons/fa";
import { RiVipCrownFill } from "react-icons/ri";
import { GiTeacher } from "react-icons/gi";
import { FcBriefcase, FcShop } from "react-icons/fc";
import { FcGraduationCap } from "react-icons/fc";
import { FcNews } from "react-icons/fc";
import WebDesignPackage from "../components/WebDesign/WebDesignPackage";
import { mergeArray, toFarsiNumber } from "../helper/helper";
import { LuShoppingCart } from "react-icons/lu";
import { FaRegBuilding } from "react-icons/fa";
import { FaLaptopCode } from "react-icons/fa";
import { FaRegNewspaper } from "react-icons/fa";
import { GrGallery } from "react-icons/gr";
import { CgWebsite } from "react-icons/cg";
import { RiVipCrown2Fill } from "react-icons/ri";
import { LuCalendar } from "react-icons/lu";
import { TbTableOptions } from "react-icons/tb";
import { getData, postData } from "../services/API";
import { MdOutlineTravelExplore } from "react-icons/md";
import Loading from "../components/shared/Loading";
import { FaHandHoldingMedical } from "react-icons/fa";
import { CartDataContext } from "../contexts/CartContext";
import { Toast } from "primereact/toast";
import CircleLoading from "../components/shared/CircleLoading";
import Input from "../components/shared/Form/Input";
import { Link, useNavigate } from "react-router-dom";
import { UserData } from "../contexts/UserInfoContext";
import { useForm } from "react-hook-form";
import { Checkbox } from "primereact/checkbox";
import { IoSettingsOutline } from "react-icons/io5";

const WebDesign = () => {
  const { register, getValues } = useForm();

  const webDesignSteps = [
    {
      id: 1,
      number: 1,
      name: "نوع سایت",
      desc: "نوع سایت خود را انتخاب کنید",
      plans: [
        {
          name: "وردپرسی",
          icon: <FaWordpress className="size-7" />,
          type: 2,
          desc: "برای کسب و کار های کوچک و نوپا",
        },
        {
          name: "اختصاصی",
          icon: <FaCode className="size-7" />,
          type: 1,
          desc: "برای استارتاپ ها کسب و کار های بزرگ",
        },
        {
          name: "اختصاصی vip",
          icon: <FaCode className="size-7" />,
          type: 3,
          desc: "برای ایده های جدید و کسب و کار های متفاوت",
        },
      ],
    },
    {
      id: 2,
      number: 2,
      name: "موضوع سایت",
      desc: "موضوع سایت خود را انتخاب کنید",
      features: [
        {
          id: 1,
          name: "طراحی سایت فروشگاهی",
          icon: (
            <LuShoppingCart className="size-7 group-hover:text-greeb-600" />
          ),
        },
        {
          id: 2,
          name: "طراحی سایت آموزشی",
          icon: <GiTeacher className="size-7 group-hover:text-greeb-600" />,
        },
        {
          id: 3,
          name: "طراحی سایت شرکتی",
          icon: <FaRegBuilding className="size-7 group-hover:text-greeb-600" />,
        },
        {
          id: 4,
          name: "طراحی سایت خبری",
          icon: (
            <FaRegNewspaper className="size-7 group-hover:text-greeb-600" />
          ),
        },
        {
          id: 5,
          name: "طراحی سایت شخصی",
          icon: <FaLaptopCode className="size-7 group-hover:text-greeb-600" />,
        },
        {
          id: 6,
          name: "طراحی سایت معرفی محصول",
          icon: <GrGallery className="size-7 group-hover:text-greeb-600" />,
        },
        {
          id: 7,
          name: "طراحی سایت گردشگری",
          icon: <GrGallery className="size-7 group-hover:text-greeb-600" />,
        },
        {
          id: 8,
          name: "طراحی سایت پزشکی و رزرو نوبت",
          icon: <GrGallery className="size-7 group-hover:text-greeb-600" />,
        },
        {
          id: 9,
          name: "سایر موارد",
          icon: <GrGallery className="size-7 group-hover:text-greeb-600" />,
        },
      ],
    },
    {
      id: 3,
      number: 3,
      name: "پکیج شما",
      desc: "پکیج طراحی سایت خود را انتخاب کنید",
      features: [],
      packages: [
        {
          id: 1,
          name: "پایه",

          price: 10,
          icon: "",
        },
        {
          id: 2,
          name: "پیشرفته",
          price: 50,
          icon: "",
        },
        {
          id: 3,
          name: "فوق پیشرفته",
          price: 100,
          icon: "",
        },
      ],
      package_features: [
        {
          id: 1,
          name: "مدیریت فروشگاه",
          options: [
            { id: 1, name: "فروش کالا", basic: true, pro: true, max: true },
            { id: 1, name: "فروش فایل", basic: false, pro: true, max: true },
            { id: 1, name: "فروش محتوا", basic: false, pro: false, max: true },
            { id: 1, name: "فروش خدمات", basic: false, pro: false, max: true },
          ],
        },
        { id: 2, name: "سئو سایت فروشگاهی", options: [] },
        { id: 3, name: "مدیریت محصولات سایت فروشگاهی", options: [] },
        { id: 4, name: "مدیریت سفارشات", options: [] },
        { id: 5, name: "ارسال محصولات", options: [] },
        { id: 6, name: "روش های پرداخت", options: [] },
        { id: 7, name: "مالی و انبارداری", options: [] },
        { id: 8, name: "وبلاگ", options: [] },
        { id: 9, name: "مدیریت کاربران", options: [] },
        { id: 10, name: "نظرات کاربران", options: [] },
      ],
    },
    {
      id: 4,
      name: "پشتیبانی پلتفرم",
      desc: "مدت زمان پشتیبانی پلتفرم خود را انتخاب کنید",
      features: [
        {
          id: 1,
          name: toFarsiNumber("1 ماهه"),
          price: 5000000,
          icon: <LuCalendar className="size-7" />,
        },
        {
          id: 2,
          name: toFarsiNumber("3 ماهه"),
          price: 12000000,
          icon: <LuCalendar className="size-7" />,
        },
        {
          id: 3,
          name: toFarsiNumber("6 ماهه"),
          price: 25000000,
          icon: <LuCalendar className="size-7" />,
        },
        {
          id: 3,
          name: toFarsiNumber("1 ساله"),
          price: 50000000,
          icon: <LuCalendar className="size-7" />,
        },
      ],
    },
    {
      id: 5,
      number: 4,
      name: "صورتحساب شما",
      desc: "صورتحساب شما",
      features: [
        {
          id: 1,
          name: toFarsiNumber("1 ماهه"),
          price: 5000000,
          icon: <LuCalendar className="size-7" />,
        },
        {
          id: 2,
          name: toFarsiNumber("3 ماهه"),
          price: 12000000,
          icon: <LuCalendar className="size-7" />,
        },
        {
          id: 3,
          name: toFarsiNumber("6 ماهه"),
          price: 25000000,
          icon: <LuCalendar className="size-7" />,
        },
        {
          id: 3,
          name: toFarsiNumber("1 ساله"),
          price: 50000000,
          icon: <LuCalendar className="size-7" />,
        },
      ],
    },
  ];

  const siteTypeIcon = {
    0: <FaHandHoldingMedical className="size-7 group-hover:text-greeb-600" />,
    1: <LuShoppingCart className="size-7 group-hover:text-greeb-600" />,
    2: <GiTeacher className="size-7 group-hover:text-greeb-600" />,
    3: <FaRegNewspaper className="size-7 group-hover:text-greeb-600" />,
    4: <FaRegBuilding className="size-7 group-hover:text-greeb-600" />,
    5: <FaLaptopCode className="size-7 group-hover:text-greeb-600" />,
    6: <GrGallery className="size-7 group-hover:text-greeb-600" />,
    7: <MdOutlineTravelExplore className="size-7 group-hover:text-greeb-600" />,
  };

  const packNames = {
    0: "پایه",
    1: "متوسط",
    2: "پیشرفته",
  };
  const { user, setUser } = useContext(UserData);
  const [activeStep, setActiveStep] = useState([webDesignSteps[0]]);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [webDesignPlans, setWebDesignPlans] = useState([]);
  const [packages, setPackages] = useState([]);
  const [webDesignPlansLoading, setWebDesignPlansLoading] = useState(true);
  const [support, setSupport] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState({});
  const [selectedSupport, setSelectedSupport] = useState({});
  const { cart, setCart, updateCart } = useContext(CartDataContext);
  const [cartButtonLoading, setCartButtonLoading] = useState(false);
  const toastLogin = useRef();
  const [requestForm, setRequestForm] = useState(false);
  const [selectedPckageCart, setSelectedPackageCart] = useState({});
  const [inCart, setInCart] = useState(false);
  const [paySubmit, setPaySubmit] = useState({});
  const [discount, setDiscount] = useState({});
  const [discountLoading, setDiscountLoading] = useState(false);
  const [saveOrderLoading, setSaveOrderLoading] = useState(false);
  const [wallet, setWallet] = useState(false);
  const [settings, setSettings] = useState(false);
  const [twoStep, setTwoStep] = useState(false);

  const [type, setType] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    getData("/shop/website/index", {}).then((res) => {
      setWebDesignPlans(res.data.plans);
      setSupport(res.data.support);
      setWebDesignPlansLoading(false);
    });
  }, []);

  const nextStepHandler = () => {
    if (activeStep.length !== 5) {
      const index = webDesignSteps.findIndex(
        (item) => item.id === activeStep[activeStep.length - 1].id
      );

      setActiveStep((prev) => [...prev, webDesignSteps[index + 1]]);
    }
  };

  const prevStepHandler = () => {
    setRequestForm(false);

    if (activeStep.length !== 1) {
      setActiveStep((prev) => prev.slice(0, -1));
    }
  };

  const actionHandler = (data) => {
    if (data.type === 3) {
      setRequestForm(true);
    } else {
      setType(data);
      nextStepHandler();
    }
  };

  const payHandler = () => {
    setCartButtonLoading(true);
    postData("/shop/website/save", {
      product_id: selectedPackage.price.id,
      support_id: selectedSupport.id,
      domarhale: twoStep ? 1 : 0,
    })
      .then((response) => {
        postData("/shop/website/pay", {
          wallet: wallet ? 1 : 0,
          domarhale: twoStep ? 1 : 0,
        })
          .then((res) => {
            if (res?.data?.gateway === "wallet") {
              navigate(
                `/order/payment?status=success&orderId=${res.data.order.id}&type=website_order`
              );

              // update profile
              getData("/user/profile", {}).then((res) => {
                setUser(res.data);
              });
            } else {
              setPaySubmit(res.data.gateway);
              setTimeout(() => {
                document.getElementById("pay_form").submit();
              }, 200);
            }

            toastLogin.current.show({
              severity: "success",
              summary: "سفارش با موفقیت ثبت شد",
              detail: "درحال انتقال شما به درگاه پرداخت...",
              life: 3500,
            });
          })
          .catch((err) => {
            setCartButtonLoading(false);

            toastLogin.current.show({
              severity: "error",
              summary: "خطا هنگام پرداخت سفارش",
              detail: err.response.data.message,
              life: 3500,
            });
          });
      })
      .catch((err) => {
        setCartButtonLoading(false);

        toastLogin.current.show({
          severity: "error",
          summary: "خطا هنگام ثبت سفارش",
          detail: err.response.data.message,
          life: 3500,
        });
      });
  };

  const submitDiscount = () => {
    setDiscountLoading(true);

    postData("/shop/discount/apply", {
      ...getValues(),
      order_id: selectedPackage.price.id,
    })
      .then((res) => {
        setDiscount(res.data);
        setDiscountLoading(false);

        toastLogin.current.show({
          severity: "error",
          summary: "با موفقیت انجام شد",
          detail: "کد تخفیف با موفقیت اعمال شد",
          life: 3500,
        });
      })
      .catch((err) => {
        setDiscountLoading(false);

        toastLogin.current.show({
          severity: "error",
          summary: "خطا هنگام اعمال کد تخفیف",
          detail: err.response.data.code,
          life: 3500,
        });
      });
  };

  const totalPrice =
    selectedPackage?.price?.price +
    (selectedPackage?.price?.price * selectedSupport?.percent) / 100 +
    (selectedPackage?.price?.price * 10) / 100;

  return (
    <div className="flex flex-col items-center justify-center mx-auto">
      <Header />
      <MobileNavbar />
      <MobileHeader />
      <ScrollTop />
      <Toast ref={toastLogin} />

      {paySubmit?.action && (
        <form
          id="pay_form"
          action={`https://sadad.shaparak.ir/VPG/Purchase?Token=${paySubmit.inputs.Token}`}
          method="GET"
        >
          <input type="hidden" name="Token" value={paySubmit.inputs.Token} />
        </form>
      )}

      <div className="w-full xl:max-w-[1300px] flex flex-col justify-center mt-5 xl:gap-4 gap-3 px-3 2xl:px-0">
        <div className="w-full flex flex-col gap-10">
          <div className="w-fit flex gap-2 text-2xl mt-3 md:text-[40px] font-black items-center pr-[50px] relative">
            <span className="text-gray-200">پکیج های</span>{" "}
            <span className="text-yellow-700">طراحی سایت</span>
            <div className="dottedSquare"></div>
          </div>

          <div className="w-full h-[1px] line-top flex justify-center items-center text-gray-200 text-xl font-black">
            فقط در چند کلیک سایت خود را سفارش دهید
          </div>

          <div className="w-full flex flex-col gap-4">
            {/* step by step */}
            <div className="w-full max-w-full web-design-steps rounded-xl">
              <div className="min-w-fit flex gap-5 bg-[#222] pb-4 px-6 rounded-xl">
                {webDesignSteps.map((step) => (
                  <div key={step.id} className="min-w-64 flex flex-col gap-4">
                    <div className="w-full flex gap-3">
                      <div
                        className={`min-w-10 h-10 -mt-4 bg-gray-800 ${
                          step.id === activeStep[activeStep.length - 1].id
                            ? "bg-yellow-700  text-white"
                            : activeStep.filter((item) => item.id === step.id)
                                .length > 0
                            ? "bg-green-500  text-white"
                            : "bg-gray-800 text-gray-200"
                        } flex items-center justify-center ring-[3px] ring-[#222] rounded-full`}
                      >
                        {step.id === activeStep[activeStep.length - 1].id ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            class="size-5"
                          >
                            <path d="M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32l8.4-8.4Z" />
                            <path d="M5.25 5.25a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3V13.5a.75.75 0 0 0-1.5 0v5.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5V8.25a1.5 1.5 0 0 1 1.5-1.5h5.25a.75.75 0 0 0 0-1.5H5.25Z" />
                          </svg>
                        ) : activeStep.filter((item) => item.id === step.id)
                            .length > 0 ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="2"
                            stroke="currentColor"
                            class="size-5"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="m4.5 12.75 6 6 9-13.5"
                            />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            class="size-4"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        )}
                      </div>

                      {/* progress */}
                      <div className="w-full rounded-full h-1 bg-gray-800 mt-2">
                        <div
                          style={{
                            width:
                              step.id === activeStep[activeStep.length - 1].id
                                ? "50%"
                                : activeStep.filter(
                                    (item) => item.id === step.id
                                  ).length > 0
                                ? "100%"
                                : "0",
                          }}
                          className={`h-full rounded-full ${
                            step.id === activeStep[activeStep.length - 1].id
                              ? "bg-yellow-700"
                              : activeStep.filter((item) => item.id === step.id)
                                  .length > 0
                              ? "bg-green-500"
                              : "bg-gray-800"
                          } transition-all duration-300`}
                        ></div>
                      </div>
                    </div>

                    <div className="flex gap-3 items-center">
                      <div className="w-10 h-14 rounded-full border flex items-center justify-center border-gray-800 text-gray-200 text-xl font-black">
                        {toFarsiNumber(step.id)}
                      </div>

                      <div className="flex flex-col gap-3">
                        <span className="text-gray-200">{step.name}</span>

                        <div
                          className={`py-2 px-3 text-sm rounded-full ${
                            step.id === activeStep[activeStep.length - 1].id
                              ? "bg-yellow-700 bg-opacity-10 text-yellow-700"
                              : activeStep.filter((item) => item.id === step.id)
                                  .length > 0
                              ? "bg-green-500 bg-opacity-10 text-green-600"
                              : "bg-gray-800 text-gray-200"
                          } transition-all duration-300 w-fit`}
                        >
                          {step.id === activeStep[activeStep.length - 1].id
                            ? "در حال تکمیل شدن"
                            : activeStep.filter((item) => item.id === step.id)
                                .length > 0
                            ? "تکمیل شده"
                            : "در انتظار تکمیل شدن"}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* active step */}
            {webDesignPlansLoading ? (
              <div className="w-full h-auto bg-[#222] flex flex-col items-center gap-4 p-4 rounded-xl">
                <Loading />
              </div>
            ) : (
              <div className="w-full h-auto bg-[#222] flex flex-col items-center gap-4 p-4 rounded-xl">
                {!user?.user?.id ? (
                  <>
                    <p className="text-xl font-black text-gray-200">
                      ابتدا وارد شوید
                    </p>
                    <Link
                      to={"/auth"}
                      className="w-fit px-6 h-10 text-sm flex items-center justify-center text-white bg-gradient-to-tl from-green-600 to-green-300 rounded-xl shadow-lg"
                    >
                      <span>ورود یا ثبت نام</span>
                    </Link>
                  </>
                ) : requestForm ? (
                  <div className="flex flex-col items-center gap-4">
                    <span className="md:text-2xl text-lg text-gray-200 font-black">
                      درخواست سایت اختصاصی vip
                    </span>
                    <span className="text-sm text-gray-400">
                      ویژگی های سایت مورد نظر خود را بنویسید تا کارشناسان ما با
                      شما تماس بگیرند
                    </span>

                    <Input
                      label={"پیام شما"}
                      placeHolder={"پیام خود را بنویسید"}
                      className={"!h-40"}
                    />

                    <button className="w-full h-10 bg-green-600 text-white rounded-xl flex justify-center items-center">
                      ثبت درخواست
                    </button>
                  </div>
                ) : (
                  <>
                    <span className="md:text-2xl text-lg text-gray-200 font-black">
                      {activeStep[activeStep.length - 1].desc}
                    </span>
                    <div className="w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                      {activeStep[activeStep.length - 1].id === 1 &&
                        activeStep[0].plans.map((plan) => (
                          <button
                            onClick={() => actionHandler(plan)}
                            className={`w-full group flex flex-col min-h-32 h-fit p-4 gap-3 items-center justify-center text-gray-200 border border-gray-800 rounded-xl hover:bg-green-500 hover:bg-opacity-10 hover:text-green-600 hover:border-green-600 transition-all duration-300`}
                          >
                            {plan.icon}

                            <span>{plan.name}</span>
                            <span className="text-xs text-yellow-600 -mt-2">
                              {plan.desc}
                            </span>
                          </button>
                        ))}

                      {/* site type */}
                      {activeStep[activeStep.length - 1].id === 2 &&
                        webDesignPlans.map((plan, index) => (
                          <button
                            onClick={() => {
                              setPackages(plan);
                              nextStepHandler();
                            }}
                            className={`w-full group flex flex-col min-h-32 h-fit p-4 gap-3 items-center justify-center text-gray-200 border border-gray-800 rounded-xl hover:bg-green-500 hover:bg-opacity-10 hover:text-green-600 hover:border-green-600 transition-all duration-300`}
                          >
                            {siteTypeIcon[index]}

                            <span>{plan.name}</span>
                          </button>
                        ))}
                    </div>
                  </>
                )}

                {/* packages */}
                {activeStep[activeStep.length - 1].id === 3 && (
                  <div className="w-full flex flex-col gap-4">
                    {/* packages */}
                    <div className="w-full grid grid-cols-4 sticky bg-[#222] py-3 top-0">
                      <div className="flex-col gap-3 text-gray-200 font-black text-4xl">
                        <span className="text-2xl hidden md:flex">
                          پکیج های طراحی سایت
                        </span>
                        <span className="text-yellow-600 hidden md:flex">
                          {packages.name}
                        </span>
                      </div>

                      {/* packages prices */}
                      {packages.products.map(
                        (pack, i) =>
                          pack.type === type.type && (
                            <div className="w-full flex flex-col gap-2 items-center justify-center">
                              <div className="flex flex-col md:flex-row items-center md:gap-2">
                                <span className="text-gray-200 font-black text-4xl md:text-6xl">
                                  {toFarsiNumber(pack.price / 1000000)}
                                </span>

                                <div className="flex flex-col items-center text-sm text-gray-400 gap-">
                                  <span>میلیـــون</span>
                                  <span>تومان</span>
                                </div>
                              </div>

                              <span className="bg-yellow-700 bg-opacity-10 text-yellow-700 rounded-full text-sm font-black py-2 px-4">
                                {pack.name}
                              </span>

                              <span className="bg-red-600 bg-opacity-10 text-red-600 rounded-full text-xs py-1 px-2">
                                {toFarsiNumber(pack.slice)} امتیاز
                              </span>

                              <button
                                onClick={() => {
                                  setSelectedPackage({
                                    package: packages,
                                    price: pack,
                                  });

                                  nextStepHandler();
                                }}
                                className="w-20 h-10 flex justify-center items-center rounded-xl bg-green-600 text-white text-sm md:text-base mt-2"
                              >
                                انتخاب
                              </button>

                              {/* {cart?.items?.filter(
                            (item) => item.info.id === pack.product_id
                          ).length > 0 ? (
                            <button
                              onClick={() => removeCartPackage(pack, packages)}
                              className="w-20 h-10 flex justify-center items-center rounded-xl bg-red-600 text-white text-sm md:text-base mt-2"
                            >
                              {cartButtonLoading &&
                              selectedPckageCart.product_id ===
                                pack.product_id ? (
                                <CircleLoading />
                              ) : (
                                "لغو"
                              )}
                            </button>
                          ) : (
                            <button
                              disabled={inCart}
                              onClick={() => addCartPackage(pack, packages)}
                              className="w-20 h-10 flex justify-center items-center rounded-xl bg-green-600 text-white text-sm md:text-base mt-2"
                            >
                              {cartButtonLoading &&
                              selectedPckageCart.product_id ===
                                pack.product_id ? (
                                <CircleLoading />
                              ) : (
                                "انتخاب"
                              )}
                            </button>
                          )} */}
                            </div>
                          )
                      )}
                    </div>

                    {/* options */}
                    <div className="w-full flex flex-col">
                      {mergeArray(
                        packages.products.filter(
                          (item) => item.type === type.type
                        )
                      ).map((option) => (
                        <div className="w-full grid grid-cols-4 border-b py-3 border-gray-800">
                          <div className="text-gray-300">{option.name}</div>

                          <div className="w-full flex justify-center items-center">
                            {option.basic ? (
                              <div className="size-6 rounded-full bg-green-500 text-white flex justify-center items-center">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke-width="3"
                                  stroke="currentColor"
                                  class="size-4"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="m4.5 12.75 6 6 9-13.5"
                                  />
                                </svg>
                              </div>
                            ) : (
                              <div className="size-6 rounded-full bg-red-500 text-white flex justify-center items-center">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke-width="3"
                                  stroke="currentColor"
                                  class="size-4"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M6 18 18 6M6 6l12 12"
                                  />
                                </svg>
                              </div>
                            )}
                          </div>

                          <div className="w-full flex justify-center items-center">
                            {option?.pro === true ? (
                              <div className="size-6 rounded-full bg-green-500 text-white flex justify-center items-center">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke-width="3"
                                  stroke="currentColor"
                                  class="size-4"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="m4.5 12.75 6 6 9-13.5"
                                  />
                                </svg>
                              </div>
                            ) : option?.pro === false ? (
                              <div className="size-6 rounded-full bg-red-500 text-white flex justify-center items-center">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke-width="3"
                                  stroke="currentColor"
                                  class="size-4"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M6 18 18 6M6 6l12 12"
                                  />
                                </svg>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>

                          <div className="w-full flex justify-center items-center">
                            {option?.max === true ? (
                              <div className="size-6 rounded-full bg-green-500 text-white flex justify-center items-center">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke-width="3"
                                  stroke="currentColor"
                                  class="size-4"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="m4.5 12.75 6 6 9-13.5"
                                  />
                                </svg>
                              </div>
                            ) : option?.max === false ? (
                              <div className="size-6 rounded-full bg-red-500 text-white flex justify-center items-center">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke-width="3"
                                  stroke="currentColor"
                                  class="size-4"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M6 18 18 6M6 6l12 12"
                                  />
                                </svg>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {/*  */}
                {/* support */}
                <div className="w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                  {activeStep[activeStep.length - 1].id === 4 &&
                    support.map((supp) => (
                      <button
                        onClick={() => {
                          nextStepHandler();
                          setSelectedSupport(supp);
                        }}
                        className={`w-full group flex flex-col min-h-32 h-fit p-4 gap-3 items-center justify-center text-gray-200 border border-gray-800 rounded-xl hover:bg-green-500 hover:bg-opacity-10 hover:text-green-600 hover:border-green-600 transition-all duration-300`}
                      >
                        <LuCalendar className="size-7" />
                        <span>{supp.name}</span>

                        {supp.percent > 0 ? (
                          <span className="text-xs text-yellow-700 -mt-2">
                            {toFarsiNumber(supp.percent)} درصد مبلغ پکیج
                          </span>
                        ) : (
                          <span className="text-xs text-yellow-700 -mt-2">
                            بدون قیمت
                          </span>
                        )}
                      </button>
                    ))}
                </div>

                {/* factor */}
                {activeStep[activeStep.length - 1].id === 5 && (
                  <div className="w-full flex flex-col items-center gap-4">
                    <div className="flex flex-col gap-2 items-center">
                      <span className="text-sm text-gray-400">
                        پکیج مورد نظر شما :
                      </span>

                      <span className="text-xl font-black text-gray-200">
                        وبسایت {selectedPackage.package.name} - پکیج{" "}
                        {selectedPackage.price.name}
                      </span>
                    </div>

                    <div className="flex flex-col gap-1 items-center">
                      <span className="text-sm text-gray-400">مبلغ پکیج :</span>

                      <div className="text-2xl font-black text-gray-200">
                        {toFarsiNumber(selectedPackage.price.price)}{" "}
                        <span className="text-base text-gray-200 font-normal">
                          تومان
                        </span>
                      </div>
                    </div>

                    <div className="flex flex-col gap-2 items-center">
                      <span className="text-sm text-gray-400">
                        بسته پشتیبانی شما :
                      </span>

                      <span className="text-xl font-black text-gray-200">
                        {selectedSupport.name}
                      </span>
                    </div>

                    <div className="flex flex-col gap-1 items-center">
                      <span className="text-sm text-gray-400">
                        مبلغ پشتیبانی :
                      </span>

                      <div className="text-2xl font-black text-gray-200">
                        {toFarsiNumber(
                          (selectedPackage.price.price *
                            selectedSupport.percent) /
                            100
                        )}{" "}
                        <span className="text-base text-gray-200 font-normal">
                          تومان
                        </span>
                      </div>
                    </div>

                    <div className="flex flex-col gap-1 items-center">
                      <span className="text-sm text-gray-400">
                        مبلغ مالیات :
                      </span>

                      <div className="text-2xl font-black text-gray-200">
                        {toFarsiNumber(
                          (selectedPackage.price.price * 10) / 100
                        )}{" "}
                        <span className="text-base text-gray-200 font-normal">
                          تومان
                        </span>
                      </div>
                    </div>

                    <div className="flex flex-col gap-1 items-center">
                      <span className="text-sm text-gray-400">جمع کل :</span>

                      <div className="text-2xl font-black text-gray-200">
                        {toFarsiNumber(twoStep ? totalPrice / 2 : totalPrice)}{" "}
                        <span className="text-base text-gray-200 font-normal">
                          تومان
                        </span>
                      </div>
                    </div>

                    <div className="max-w-96 w-full flex flex-col gap-4">
                      {/* <Input
                        element={"input"}
                        label={"کد تخفیف"}
                        placeHolder={"کد تخفیف دارید ؟ وارد کنید"}
                        className={"placeholder:!text-sm"}
                        register={{ ...register("code") }}
                      />

                      <button
                        onClick={submitDiscount}
                        className="text-white py-2 px-4 flex items-center justify-center rounded-xl bg-gradient-to-tl from-red-700 to-red-500"
                      >
                        {discountLoading ? <CircleLoading /> : "اعمال کد تخفیف"}
                      </button> */}

                      <div className="mt-2 flex flex-col gap-2">
                        <div className="text-gray-200 flex items-center gap-2">
                          <Checkbox
                            inputId="pay-method"
                            checked={wallet}
                            onChange={(e) => setWallet(e.checked)}
                            disabled={
                              user?.user?.wallet - totalPrice > 0 ? false : true
                            }
                          ></Checkbox>
                          <label
                            htmlFor="pay-method"
                            className={`w-full flex items-center ${
                              user?.user?.wallet - totalPrice > 0
                                ? "cursor-pointer"
                                : "cursor-not-allowed"
                            } `}
                          >
                            <span>پرداخت با کیف پول</span>
                            <span className="text-xs text-gray-400 block mr-1">
                              ( موجودی: {toFarsiNumber(user?.user?.wallet)}{" "}
                              تومان )
                            </span>
                          </label>
                        </div>

                        {user?.user?.wallet - totalPrice < 0 && (
                          <div className="flex justify-between gap-2 items-center">
                            <span className="text-sm text-red-600">
                              صورتحساب از موجودی کیف پول شما بیشتر است
                            </span>
                          </div>
                        )}
                      </div>

                      <button
                        onClick={payHandler}
                        className="text-white py-2 px-4 flex items-center justify-center rounded-xl bg-gradient-to-tl from-green-700 to-green-500"
                      >
                        {cartButtonLoading ? (
                          <CircleLoading />
                        ) : (
                          "پرداخت صورتحساب"
                        )}
                      </button>

                      <button
                        onClick={() => setSettings(!settings)}
                        className={`flex items-center ${
                          settings ? "text-yellow-700" : "text-gray-200"
                        } gap-1 text-xs hover:text-yellow-700 -mt-2`}
                      >
                        <IoSettingsOutline className="size-4" />
                        <span>تنظیمات</span>
                      </button>

                      {settings && (
                        <div className="text-gray-200 flex items-center text-sm gap-2 slide-up">
                          <Checkbox
                            inputId="two-step"
                            checked={twoStep}
                            onChange={(e) => setTwoStep(e.checked)}
                          ></Checkbox>

                          <label htmlFor="two-step" className="cursor-pointer">
                            پرداخت دو مرحله ای
                          </label>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                <div className="w-full flex justify-between items-center sticky bottom-0 bg-[#222] py-3 gap-5">
                  <button
                    onClick={prevStepHandler}
                    className="bg-red-500 bg-opacity-10 text-red-600 shadow-lg py-2 px-4 rounded-xl "
                  >
                    قبلی
                  </button>

                  {(activeStep[activeStep.length - 1].id !== 5 ||
                    !requestForm) && (
                    <button
                      onClick={() => {
                        inCart && nextStepHandler();
                      }}
                      className="py-2 px-4 bg-green-500 bg-opacity-10 text-green-600 shadow-lg rounded-xl"
                    >
                      بعدی
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>

          {/* <div className="flex flex-col md:flex-row gap-4 justify-center">
            {packages.map((pack) => (
              <WebDesignPackage pack={pack} />
            ))}
          </div> */}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default WebDesign;
